module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-1-tablet-09dcc2c5c8f4f04f89cd717d8ed6510c.png";